export default "/images/chevrons-left.svg?13ee170446da2ec160bded549df59974";